var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoProduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3827_20047",
    transform: "scale(0.0142857)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3827_20047",
    width: 70,
    height: 70,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABGCAYAAABxLuKEAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKNSURBVHgB7Zp9TxpBEMandwItlfASUkNLjX7/D6R/tNFYWitShJBaKS/tzSbbkOoD3u3uuZrnlxAghM3yu9nZmeVefTo5+SPkHomQB6EYAMUAKAZAMQCKAVAMgGIAFAOgGADFACgGQDEAigFQDIBiABQD2BNHkiSRt42GxMJqtZLf87ksFwtxwUnMXqUiHw4PzXNMqJQvZ2eyXq+lKE5iNFJUyreLC1k4XiFfpGkq/aMjabRaMh2PpShOYnQZKb9ubyUW7BKycysKky+AYgAUA6AYAMUAnAu8UOiu0ux05E29LvOsYLu5vnaqS/ISrZjuwYE0mk3zWuWss4r2ZjSSsoh2KamMbe9DE62Y/yvpZcmVdWliNGe8znHVvw8GMptOjZBJVtqPrq6kTErJMe1uVzrZQ5nf3Znealci1c+Hl5fyVASPGCtFGzr9oZVqVd5nHblrLxOaoLOzUnQ3GQ2HZmlotDwHOcFmtillvLHN2qUUu5wgs0JSLEXl1Pf3zdjVWk1C413MLimWvHJ03F6/b8b+eHz8r/gLhVcxj5VieayczXE/n56aXPWu1wsqx5uYvFIsu+Q8NK7ubqHleBFTVIoFydk2bmg5Xgo8FykWK0fFaA7RlkD7o23j2gJQ5SgqyhdeIsZVisXK0f+GKtm/Dz+y2mfXuKEix0vE+JBiUTmD8/M8X7kXOT6I9jwmL77lvKijTbusfPDiznx9deQ8DAdQDMAp+drDJm3qyjzB34a988J1Pk5iZpOJtNptU5DFhB6H/pzNxAXniPmaFWS1LGKSNJVYUClPGjGKXp1lJPfG+ITJF0AxAIoBUAyAYgAUA6AYAMUAKAZAMQCKAVAMgGIAFAOgGADFACgG8Bf2wkMes+Ga8QAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProduct);
export default __webpack_public_path__ + "static/media/no-product.a4c0ea8a329db62a93f95cc751e8c3a4.svg";
export { ForwardRef as ReactComponent };